<template>
    <div>
        <button class="btn btn-primary px-8 font-bold rounded-full" @click="openModal()">
            {{ label }}
        </button>

        <Modal
            v-if="showModal"
            modal-title="Apply"
            close-confirm-message="Entered data will be discarded, are you sure?"
            @close="showModal = false"
        >
            <template v-slot:body>
                <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
                    <span v-if="jobType == 1">
                        <my-input
                            v-model="form.amount"
                            type="number"
                            name="amount"
                            :error="form.errors.get('amount')"
                            label="Your Bid (in US Dollars)"
                            class=""
                            placeholder="e.g. 200"
                        />
                        <div class="mb-4 text-gray-500 text-sm">
                            Optional
                        </div>

                        <div class="flex items-start mb-4">
                            <div class="w-2/3 mr-4">
                                <my-input
                                    v-model="form.duration"
                                    type="number"
                                    name="duration"
                                    :error="form.errors.get('duration')"
                                    label="Delivery Time"
                                    placeholder="e.g. 4"
                                />
                            </div>
                            <div class="w-1/3">
                                <my-select
                                    v-model="form.duration_unit"
                                    label="Unit"
                                    name="duration_unit"
                                    :error="form.errors.get('duration_unit')"
                                    :options="{
                                        day: 'Day(s)',
                                        week: 'Week(s)'
                                    }"
                                />
                            </div>
                        </div>
                    </span>

                    <my-textarea
                        v-if="jobType == 1"
                        v-model="form.notes"
                        name="notes"
                        :error="form.errors.get('notes')"
                        label="Add Notes"
                        class="mb-4 h-48"
                    />

                    <my-textarea
                        v-else
                        v-model="form.notes"
                        name="notes"
                        :error="form.errors.get('notes')"
                        label="Cover Letter"
                        class="mb-4 h-48"
                    />
                </form>
            </template>
            <template v-slot:footer>
                <my-button :loading="submitting" class="btn btn-primary float-right" @click="submitForm">
                    <i class="fa fa-save"></i> Submit Bid
                </my-button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Form from '../../forms/form';
import { delay } from '../../utils';

export default {
    props: {
        projectSlug: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: 'Apply'
        },
        bid: {
            type: Object,
            default: null
        },
        jobType: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            submitting: false,
            showModal: false,
            form: new Form({
                amount: this.bid ? this.bid.amount : null,
                duration: this.bid ? this.bid.duration : null,
                duration_unit: this.bid ? this.bid.duration_unit : 'day',
                notes: this.bid ? this.bid.notes : null
            })
        };
    },

    methods: {
        submitForm() {
            this.submitting = true;
            this.submitRequest()
                .then(async () => {
                    flash.success();
                    this.showModal = false;
                    NProgress.inc();
                    await delay(1000);
                    NProgress.done();
                    window.location.reload();
                })
                .catch(() => {
                    if (this.form.errors.any()) {
                        flash.error({ message: 'It seems like you have submitted invalid data.' });
                        return;
                    }
                })
                .finally(() => (this.submitting = false));
        },

        submitRequest() {
            if (this.bid) {
                return this.form.put(`/api/bids/${this.bid.id}`);
            }

            return this.form.post(`/api/projects/${this.projectSlug}/bid`);
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        },

        openModal() {
            if (!this.authUser()) {
                //yagankar.bus.emitEvent('login-needed');
                flash.error({ message: 'You need to login first.' });
                return;
            }

            if (!this.authUser().is_profile_public) {
                flash.error({ message: 'You cannot bid until you make your profile public.' });
                return;
            }

            this.showModal = true;
        }
    }
};
</script>
